import { React } from "react";   
const QRcodeWelcomeMessageEN = () => {
    return (
        <h4 className="instructions">
            Dear participant, you may redeem this QR-code to become one of the first 
            pilot-tester of GlucoNutris app when it will be operational, hopefully
            during summer 2023. To do that please send us a copy of your QR-code 
            with e-mail by clicking on "Contact" at the bottom of the screen 
            and we will contact you shortly. You can get access to your QR-code by 
            logging into your account or you can take a screen copy and save it.
            Once again, thank you for your time. GlucoNutris team.

        </h4>


    )
    
}
export default QRcodeWelcomeMessageEN